<template>
    <v-container class=" mt-12 pt-8" style="background:#fafafa;">
      <v-row class="mx-5  align-center justify-center ">
        <v-col cols="12"  md="7"  class=" justify-center">
          <v-card>
            <v-card-text class="py-0">
              <v-row  :class="arabic ? `arFont` : 'enFont'">
                <v-col cols="12" class="text-center" :class="arabic ? `arFont` : 'enFont'">
                  <div :class="localizedClass('grey--text')">{{ i18n['ordertracking'] }}</div>
                </v-col>
               </v-row>
               <v-row class="align-center justify-center">
                <v-col cols="12" :class="arabic ? `arFont` : 'enFont'" md="3" class="py-0 d-flex justify-center mx-5 my-5">
                  <v-text-field
                    :label="i18n['search_by_document_number']"
                    outlined
                    :loading="loading"
                    :class="localizedClass()"
                    hide-details
                    v-model="search"
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3" :class="arabic ? `arFont` : 'enFont'" class="py-0 d-flex justify-center">
                  <v-btn
                    color="secondary"
                    block
                    :loading="loading"
                    :class="localizedClass()"
                    @click="trackOrders"
                  >
                    {{ i18n["track"] }}
                    <v-icon right size="15">search</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="12" class="text-center pa-2">
                  <v-progress-circular v-if="loading" color="primary" indeterminate></v-progress-circular>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
        <v-row :class="arabic ? `arFont` : 'enFont'" v-if="dataTracking && dataTracking.length > 0" class="justify-center mx-5 my-10">
        <v-col cols="12" md="7" v-for="(item, index) in dataTracking" :key="index" class="mx-4">
            <v-card class="mx-auto my-auto">
            <v-card-title>{{ item.content }}</v-card-title>
            <v-card-subtitle>{{ formatDate(item.created_at) }} - {{ formatTime(item.created_at) }}</v-card-subtitle>
            <v-card-text>
            {{ item.lead.address }}
            </v-card-text>
            </v-card>
        </v-col>
        </v-row>

    </v-container>
  </template>
  
  <script>
 export default {
  data() {
    return {
      loading: false,
      search: '', 
      dataTracking: [], 
    };
  },
  computed: {
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      return this.$store.state.language === 'ar';
    },
  },
  methods: {
    localizedClass(baseClass = '') {
      return `${this.arabic ? 'arFont' : 'enFont'} ${baseClass}`;
    },

    async trackOrders() {
      const searchValue = this.search || this.$route.params.document_number;

      if (!searchValue || searchValue === '0' || searchValue === '#') {
        console.warn("Search term is empty or invalid.");
        return;
      }

      this.loading = true;
      try {
        const response = await fetch(`https://yervip.com/api/v1/lead-updates/show?search=${encodeURIComponent(searchValue)}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const data = await response.json();
        this.dataTracking = Array.isArray(data) ? data : [];

        if (this.dataTracking.length === 0) {
          console.warn('No matching data found.');
        }
      } catch (error) {
        console.error('Error fetching  data:', error);
        this.dataTracking = [];
      } finally {
        this.loading = false;
      }
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toISOString().split('T')[0]; 
    },
    formatTime(dateString) {
      const date = new Date(dateString);
      let hours = date.getHours();
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12 || 12; 
      return `${hours}:${minutes}:${seconds} ${ampm}`;
    },
  },
  
  created() {
    const documentNumber = this.$route.params.document_number;
    if (documentNumber && documentNumber !== '0' && documentNumber !== '#') {
      this.search = documentNumber;
      this.trackOrders();
    }
  },
};
  </script>
  
  <style>
  </style>
  